module.exports = __webpack_public_path__ + "static/media/Servicemenumanual_version_3_2022.4b292f2b.pdf";